export const additionalTopSlotsIds = [
  'BonanzaBillion',
  '35780',
  'bookofdead_png',
  '37994',
  'belatra:MummylandTreasures',
  '38129',
  'vs20olympx',
  '36629',
  'BurningChilliX',
  '61250',
  'playson:CoinStrike2HoldandWin',
  '31895',
  'reactoonz_png',
  '31835',
  'starburst_touch',
  '63104',
  'lebandit_hs',
  '31867',
  'vs20fruitsw',
  '65018',
  'belatra:BlasttheBass',
  'WildTiger',
  'gonzos_quest_touch',
  'SlotMachine_MajesticKong',
  'playson:DiamondsPowerHoldandWin',
  '5063',
  'vs20sugarrushx',
  'moneytrain3_rg',
  'FruitMillion',
  'wanted_dead_or_a_wild',
  'quickspin:GoldenGlyph2',
  'playson:RoyalCoins2HoldandWin',
  'endorphina2_HellHot100@ENDORPHINA',
  'vs5joker',
  'belatra:MakeitGold',
  'legacyofdead_png',
  'AztecMagicMegaways',
  'twin_spin_touch',
  '1908',
  'vs10bbbonanza',
  'playson:SuperchargedCloversHoldandWin',
  'templetumble_rg',
  'qso_bbw',
  'moonprincess_png',
  'SlotMachine_MajesticKing',
  'JokersMillion',
  'playson:ThunderCoinsHoldandWin',
  '135',
  'endorphina2_3LuckyStreak@ENDORPHINA',
  'quickspin:StickyBandits3MostWanted',
  'firejoker_png',
  'endorphina2_JokerStoker@ENDORPHINA',
  'evoplay:FruitSuperNova',
  '804',
  '813',
]
